// extracted by mini-css-extract-plugin
module.exports = {"Root":"ColumnIcon_Root__3RBnT","Bar":"ColumnIcon_Bar__oBEfn","NoBar":"ColumnIcon_NoBar__27Pft"};